import { gsap, ScrollTrigger } from "../layout";

document.addEventListener('DOMContentLoaded', () => {
    // cf7 thank you page
    var contactForm = document.querySelector(".wpcf7-form");
    contactForm.addEventListener('wpcf7mailsent', function (event) {
        location = thanksUrl;
    }, false);

    // ---=== tel input number and "+" is allowed ===---
    function setInputFilter(textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
            textbox.addEventListener(event, function(e) {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        });
    }
    // init setInputFilter
    setInputFilter(document.getElementById("inputName"), function(value) {
        return /^[ a-zA-Z]*$/.test(value); // Allow digits and '.' only, using a RegExp
    }, "Only text is allowed");

    // prevent enter on submit
    document.querySelector(".wpcf7-form").onkeypress = function(e) {
        let key = e.charCode || e.keyCode || 0;     
        if (key == 13) {
            e.preventDefault();
        }
    }
})

window.addEventListener('resize', () => {
    
})